import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView,
	Dimensions, FlatList, AsyncStorage, Linking, I18nManager, Platform } from "react-native";

import { format, parse } from 'date-fns'

import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import MainComponent from "../utilities/MainComponent";
import i18n from 'i18n-js';
import AppContext, {AppProvider} from "../utilities/AppContext"
import { payment } from "../config/payment"

export default class ReceiptScreen extends MainComponent {	
	
	static path = "receipt"
	state = {
		tax : 0,
		store: {currency: ""},
		totalPrice: 0,
		store: {currency: ""},
		isLoading: false,
		deliveryData: {area: {name: ""}},
		userData : [],
		orderData: [],
		mainData: {currency: ""},
		showReceipt: false,
		showFullMode 	: true,
		isLoading: false,
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false
				
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		if(this.context === undefined || this.context.receiptData === undefined){
			this.props.navigation.navigate('status')
			return								
		}

		this.state.mainData    = this.context.receiptData.data
		this.state.showReceipt = this.context.receiptData.showReceipt

		this.state.orderData	= this.state.mainData.orderData
		this.state.deliveryData = this.state.mainData.deliveryData
		this.state.promoData 	= this.state.mainData.promoData		
		
		if(this.state.promoData == [])
			this.state.promoData = undefined

		this.state.userData	  = this.state.mainData.userData
		this.state.totalPrice = this.state.mainData.totalPrice
		this.state.tax 		  = this.state.mainData.taxCharges

		this.getDetails()
	}

	getDetails = async () => {				
		await Font.loadAsync(color.appFonts);
		try {
            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})            
        } catch (error) {
            console.log(error)
		}
	}
	
	backBtnPressed(){
		this.props.navigation.goBack(null)
	}

	renderListItem = ({ item, index }) => 
	{	
		var modifiers = ""	
		if (item.counter == undefined)
			item.counter = 1
		
		if(item.addons == undefined){
			item.addons = []
		}

		item.addons.map(mObj => {
			if(mObj.modifiers == undefined)
				mObj.modifiers = []

			mObj.modifiers.map(obj => {
				if(modifiers == '')
					modifiers = obj.name
				else
					modifiers = modifiers + ", " + obj.name
			})
		})
	
		return (
			
			<View  style={{backgroundColor:"white", height: 35, marginLeft: 15, flexDirection: "row", marginRight: 15, justifyContent: "center", alignContent: "center", alignItems: "center"}}>	
				<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 14 }}>{item.counter}x</Text>			
				<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 14, marginLeft: 10 }}>{item.name}</Text>
				{ I18nManager.isRTL && (
					<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 14, marginLeft: "auto", marginRight:0}}>{item.totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.mainData.currency.toLowerCase())}</Text>
				)}
				{ !I18nManager.isRTL && (
					<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 14, marginLeft: "auto", marginRight:0}}>{i18n.t('currency.' + this.state.mainData.currency.toLowerCase())} {item.totalPrice.toFixed(3)} </Text>
				)}
			</View>
		);
	}

	callOnPhone = async () => {
		var str = store.phone;
		var phoneString = str.replace(/-/g, "");
		const url = `tel:${phoneString}`;

		Linking.canOpenURL(url)
			.then((supported) => {
				if (supported) {
					return Linking.openURL(url)
						.catch(() => null);
				}
			});
	}

	startOver(){
		this.props.navigation.navigate('menu')
	}
	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	renderDetails(){

		var icoName = "ios-arrow-back"
		if(!I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		let height = 2.5
		var paymentType = ""
		if(this.state.mainData.payType == payment.PAY_BY_KNET)
			paymentType = i18n.t("knet")
		else if(this.state.mainData.payType == payment.PAY_BY_CASH)
			paymentType = i18n.t("payCash")
		else if(this.state.mainData.payType == payment.PAY_BY_CARD)
			paymentType = i18n.t("card")

			var timings = ""
			if(this.state.deliveryData != undefined && this.state.deliveryData.timings != undefined && this.state.deliveryData.timings != "")
			{
				try{
					timings = format(parse(this.state.deliveryData.timings.date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  this.state.deliveryData.timings.data.openingTime + " - " + this.state.deliveryData.timings.data.closingTime
				}catch{
					timings =  i18n.t(this.state.deliveryData.timings.date, {defaultValue: this.state.deliveryData.timings.date})
				}
			}

		var mainArea = ""
		if(this.state.userData.block != undefined && this.state.userData.block != "")			
			mainArea = i18n.t("block") + " " + this.state.userData.block 
		if(this.state.userData.street != undefined && this.state.userData.street != "")			
			mainArea += " , " + i18n.t("street") + " " + this.state.userData.street 
		if(this.state.userData.avenue != undefined && this.state.userData.avenue != "")			
			mainArea += " , " + i18n.t("avenue") + " " + this.state.userData.avenue 
		if(this.state.userData.building != undefined && this.state.userData.building != "")			
			mainArea += " , " + i18n.t("building") + " " + this.state.userData.building 
		if(this.state.userData.floor != undefined && this.state.userData.floor != "")			
			mainArea += " , " + i18n.t("floor") + " " + this.state.userData.floor 
		if(this.state.userData.house != undefined && this.state.userData.house != "")		
		{	
			if(this.state.userData.unitType == 0)
				mainArea += ", " + i18n.t("house") + " # "
			else if(this.state.userData.unitType == 1)
				mainArea += ", " + i18n.t("office") + " # "
			else if(this.state.userData.unitType == 2)
				mainArea += ", " + i18n.t("appartment") + " # "
			mainArea += this.state.userData.house 
		}
						
		mainArea = mainArea.replace(", ,", "")

		var branchName = ""
		var areaName = ""
		if(this.state.deliveryData != undefined && this.state.deliveryData.branch != undefined)
		{
			branchName = this.state.deliveryData.branch.name + " - " + this.state.deliveryData.branch.address
			if(i18n.locale != this.state.store.defaultLanguage){
				branchName  = this.state.deliveryData.branch.nameSecondary + " - " + this.state.deliveryData.branch.addressSecondary
			}	
		}

		if(this.state.deliveryData != undefined && this.state.deliveryData.area != undefined)
		{
			if(I18nManager.isRTL)
				areaName = this.state.deliveryData.area.nameArabic
			else
			   areaName = this.state.deliveryData.area.name
		}

		var taxPrice = this.state.tax.toFixed(3)
		if(I18nManager.isRTL)
			taxPrice = taxPrice + " " + i18n.t('currency.' + this.state.mainData.currency.toLowerCase())
		else
			taxPrice = i18n.t('currency.' + this.state.mainData.currency.toLowerCase()) + " " + taxPrice

		var deliveryChargesText = "-"
		if(this.state.mainData.deliveryCharges != undefined && this.state.mainData.deliveryCharges > 0)
		{
			if(I18nManager.isRTL)
				deliveryChargesText = this.state.mainData.deliveryCharges + " " + i18n.t('currency.' + this.state.mainData.currency.toLowerCase())
			else
				deliveryChargesText = i18n.t('currency.' + this.state.mainData.currency.toLowerCase()) + " " + this.state.mainData.deliveryCharges
		}

		return (
			<View style={styles.container}>

				<View style={{height: height, flexDirection: "row", marginTop: 50}}>

					<View style={{height: height, width: 5}}/>
					{ this.state.store != undefined  && (	
						<View>		
							<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
							<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
							<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
							<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
						</View>
					)}	

				</View>
				{ this.state.showError  && (
					<View style={{height: 25, backgroundColor: 'red', justifyContent: "center", alignContent: "center", alignItems: "center"}}>
							<Text style={{ fontFamily: 'main-regular',color:color.details, fontSize:14, color: "white", textAlign: "center"}}>{this.state.errorMessage}</Text>		
					</View>
				)}
				
				<ScrollView style={{flex: 1, backgroundColor:color.bigSeparator, width: "100%"}}>
					
					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

					<View style={{justifyContent: "center", width: "100%", backgroundColor: 'white'}}>

							<View style={{paddingLeft: 15, paddingRight: 15, height: 40, backgroundColor: 'white'}}
												
												>
													<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
														<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>{i18n.t("orderItems")}</Text>	
														<Ionicons style={{marginLeft: "auto",}} size={20} color='black' />	
													</View>
			
							</View>

							<View style={{flex: 1}}>
								<FlatList
									extraData={this.state}
									data={this.state.orderData}
									renderItem={this.renderListItem}
									keyExtractor={item => item.name}
								/>
							</View>
					</View>

					<View style={{height: 4,backgroundColor:'white'}}/>
					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

					{ this.state.deliveryData.area != undefined && (
						<View>

							<View style={{paddingLeft: 15, paddingRight: 15, height: 40, backgroundColor: 'white'}}
												onPress={() => { 
															//this.openOrders() 
														}}
									>
										<View style={{flexDirection: "row", flex:1, alignItems:"center", alignItems: "center"}}>
											<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "left"}}>{i18n.t("deliveryInfo")}</Text>	
										</View>

							</View>

							<View style={{flexDirection: "row", height: 50, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} >
								<Ionicons style={{marginRight: 5}} name="ios-calendar" size={20} color='black' />	
								<Text style={{marginLeft: 10, fontFamily: 'main-regular',color: 'black', fontSize:14, textAlign: "center"}}>{timings}</Text>	
							</View>

							<View style={{height: 1,backgroundColor:color.bigSeparator}}/>
							
								<View style={{flexDirection: "row", minHeight: 65, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} 
									
								>						
									<Ionicons style={{marginRight: 5}} name="md-business" size={20} color='black' />	
									<View style={{marginLeft: 10, marginRight: 10, flex: 1}} >
											<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{areaName}</Text>	
											<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14}}>{mainArea}</Text>	
									</View>
								</View>

								<View style={{height: 1,backgroundColor:color.bigSeparator}}/>

								<View style={{backgroundColor: 'white', flexDirection: "row", height: 65, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center"}} 
											
									>

									<Ionicons style={{marginRight: 5}} name="md-locate" size={20} color='black' />	
									<View style={{marginLeft: 10}} >
											<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.userData.name}</Text>	
											<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.userData.phone}</Text>	
									</View>
								</View>	
						</View>
					)}

					{ this.state.deliveryData.branch != undefined && (
						<View>

							<TouchableOpacity style={{paddingLeft: 15, paddingRight: 15, height: 40, backgroundColor: 'white'}}
										onPress={() => { 
											var url = 'http://maps.google.com/maps?saddr='+ this.state.deliveryData.branch.storeCoords.lat + ',' + this.state.deliveryData.branch.storeCoords.lng;
											window.open(url, "_blank") 
										}}		
									>
										<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
											<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>{i18n.t("pickup")}</Text>	
											<Ionicons style={{marginLeft: "auto",}} size={20} color='black' />	
										</View>

							</TouchableOpacity>

							<View style={{flexDirection: "row", height: 50, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} >
								<Ionicons style={{marginRight: 5}} name="ios-calendar" size={20} color='black' />	
								<Text style={{marginLeft: 10, fontFamily: 'main-regular',color: 'black', fontSize:14, textAlign: "center"}}>{branchName}</Text>	
							</View>

						</View>
					)}

					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>	

						<Text style={{textAlign:"left", paddingTop: 10, paddingLeft: 15, fontFamily: 'main-bold', color: 'black', fontSize:14, backgroundColor: 'white'}}>{i18n.t("paymentMethod")}</Text>	
						<View style={{paddingLeft: 15, paddingRight: 15, height: 40, paddingTop: 10, backgroundColor: 'white'}}												
							>
									<Text style={{fontFamily: 'main-regular', color: 'black', fontSize:14, textAlign: "left"}}>{paymentType}</Text>	
					</View>

					<View style={{height: 8,backgroundColor:'white'}}/>		
					<View style={{height: 10,backgroundColor:color.bigSeparator}}/>		

					<View style={{height: 15,backgroundColor:'white'}}/>		
						<View style={{flex: 1, flexDirection: "row", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12}}>{i18n.t("delivery")}</Text>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginLeft: "auto"}}>{deliveryChargesText}</Text>
						<View style={{height: 10,backgroundColor:'white'}}/>		
					</View>

					<View style={{height: 15,backgroundColor:'white'}}/>		
						<View style={{flex: 1, flexDirection: "row", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12}}>{i18n.t("tax")}</Text>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginLeft: "auto"}}>{taxPrice}</Text>
						<View style={{height: 10,backgroundColor:'white'}}/>		
					</View>

					{ this.state.promoData != undefined && this.state.promoData.discount != undefined && (
					<View style={{flex: 1, flexDirection: "row", paddingRight: 15, paddingLeft: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 15, fontWeight:"bold"}}>{i18n.t("promoDiscount")}</Text>
						{ I18nManager.isRTL && (
							<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>{this.state.promoData.discount(3)} {i18n.t('currency.' + this.state.mainData.currency.toLowerCase())}</Text>
						)}
						{ !I18nManager.isRTL && (
							<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>{i18n.t('currency.' + this.state.mainData.currency.toLowerCase())} {this.state.promoData.discount(3)}</Text>
						)}
					</View>
					)}

					<View style={{flex: 1, flexDirection: "row", paddingRight: 15, paddingLeft: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold"}}>{i18n.t("total")}</Text>
						{ I18nManager.isRTL && (
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto", height: 45}}>{this.state.totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.mainData.currency.toLowerCase())}</Text>
						)}
						{ !I18nManager.isRTL && (
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto", height: 45}}>{i18n.t('currency.' + this.state.mainData.currency.toLowerCase())} {this.state.totalPrice.toFixed(3)}</Text>
						)}
					</View>

					<View style={{height: 15,backgroundColor:'white'}}/>		

				</ScrollView>
				{ this.state.showReceipt && (
				<View style={{height: 65, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
				
					<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.startOver() }}
								>
					<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:store.primaryColor}}>
						
							{ this.state.isLoading  && (
								<ActivityIndicator style={{marginRight: 5}} size="small" color='white' /> 
							)}
							{ !this.state.isLoading  && (
								<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{i18n.t("startOver")}</Text>		
							)}
					</View>

					</TouchableOpacity>

				</View>
				)}
			</View>
		)
	}

	render() {
		var that = this
		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails()}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("orderDetails")}</Text>																						
								</View>	
								<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails()}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("orderDetails")}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
									onPress={() => { this.props.navigation.goBack(null) }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>

		)}	
		</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});